import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
function Header() {
    return (
        <Fragment>
            <div className='d-flex justify-content-center align-items-center p-2'>
                <Link to='/' className="navbar-brand fw-bold fs-3">Ideas<span className='text-success'>Digitales</span></Link>
            </div>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className='container-fluid'>
                    <Link to='/' className="navbar-brand fw-bold">Ideas<span className='text-success'>Digitales</span></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse m-auto" id="navbarColor02">

                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link className="nav-link active" to="/">Inicio
                                    <span className="visually-hidden">(current)</span>
                                </Link>
                            </li>
                            <li>
                                <HashLink to="/#noticias" className='nav-link'>Noticias</HashLink>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/proveedores">Proveedores</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/empleados">Empleado</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/tienda">Tienda</Link>
                            </li>
                            <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Tablas
                            </Link>
                            <ul className="dropdown-menu">
                                <li>
                                    <Link className="dropdown-item" to="/categoria">Categorias</Link>
                                </li>
                            </ul>
                        </li>

                        </ul>


                    </div>
                    <div className="d-flex">
                        <Link className='text-white' to="/carrito"><i className="fa-solid fa-cart-shopping text-white"></i></Link>
                    </div>
                </div>
            </nav>
        </Fragment>
    )
}

export default Header